import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { VehicleService } from '../../_services/_masters/vehicle.service';
import { Subject } from 'rxjs';
import 'rxjs/add/operator/map';
import { Http, Response } from '@angular/http';
import { environment } from '../../../environments/environment';

import { SelectablesService } from '../../selectables.service';

import swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
// import * as $ from 'jquery';
declare var $ : any;

class VehicleForm {
	owner_name:string;
	truck_no : string;
	branch: string;
	pan_no: string;
	account_no: string;
	bank_name: string;
	bank_branch: string;
	bank_ifsc: string;
	
}

@Component({
  selector: 'app-vehicle',
  templateUrl: './vehicle.component.html',
  styleUrls: ['./vehicle.component.css']
})

export class VehicleComponent implements OnInit {

	vehicleForm : FormGroup;
	modalVehicleForm : FormGroup;
	check_branch: boolean = true;
	modalData : any;

	// Data Table Configurations
	dtOptions: any = {};
	dataTable: any;
	dtTrigger: Subject<any> = new Subject();
	vehicle_form: VehicleForm[] = [];

	stations : string[] = [];
	currentUser  : any ;
	token : any ;
	user_role : string = null ;
	user_branch : string = null ;
	url =environment.url;
	@ViewChild(DataTableDirective)
	dtElement: DataTableDirective;

	query : any = null;
	response : any = null;
	
	constructor( private vehicleService : VehicleService, 
				private selectBranchService : SelectablesService,
				private http: Http) { }

	ngOnInit() {

		this.vehicleForm = new FormGroup({
			'owner_name': new FormControl(null , Validators.required),
			'truck_no' :  new FormControl(null , Validators.required),
			'branch':  new FormControl(null , Validators.required),
			'pan_no':  new FormControl(null , Validators.required),
			'account_no':  new FormControl(null , Validators.required),
			'bank_name':  new FormControl(null , Validators.required),
			'bank_branch':  new FormControl(null , Validators.required),
			'bank_ifsc':  new FormControl(null , Validators.required)
		});
		
		this.modalVehicleForm = new FormGroup({
			'owner_name': new FormControl(null , Validators.required),
			'truck_no' :  new FormControl(null , Validators.required),
			'branch':  new FormControl(null , Validators.required),
			'pan_no':  new FormControl(null , Validators.required),
			'account_no':  new FormControl(null , Validators.required),
			'bank_name':  new FormControl(null , Validators.required),
			'bank_branch':  new FormControl(null , Validators.required),
			'bank_ifsc':  new FormControl(null , Validators.required)
		});


		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 5,
			responsive: true,
			// select:true,
			rowCallback: (row: Node, data: any[] | Object, index: number) => {
				const self = this;
				// Unbind first in order to avoid any duplicate handler
				// (see https://github.com/l-lin/angular-datatables/issues/87)
				$('td', row).unbind('click');
				$('td', row).bind('click', () => {
					self.someClickHandler(data);
				});
				return row;
			},
			dom: 'Bfrtip',
			// Configure the buttons
			buttons: [
				// 'columnsToggle',
				'colvis',
				'copy',
				'print',
				'excel'
			]
		};

		this.http.get( this.url + '/masters/vehicle/all')
		// this.http.get('http://backendtransport.iogreen.in/masters/consignor/all')
			.map(this.extractData)
			.subscribe(forms => {
				this.vehicle_form = forms;
				console.log(this.vehicle_form);
				// Calling the DT trigger to manually render the table
				this.dtTrigger.next();
			});


		var myObject = localStorage.getItem('currentUser');
		var temp = JSON.parse(myObject);	
		if(localStorage.getItem('currentUser'))
		{
			if (temp["role"] === 'Admin')
			{
				this.getBranch();
				this.check_branch = false;
			}
			else if(temp['role'] === 'Manager' || temp['role'] === 'Employee')
			{
				console.log(temp['branch'])
				this.vehicleForm.get('branch').patchValue(temp['branch']);
				this.check_branch = true;
			}
		}
	}
	getBranch()
    {
     	this.selectBranchService.getBranches()
		.subscribe(
			branches => {
				for(var i=0;i<branches.length;i++)
				{
					this.stations.push(branches[i]['branch_name']);
				}
			});
    }
	
	private extractData(res: Response) {
		const body = res.json();
		console.log(body.data || {});
		return body;

	};

	someClickHandler(info: any): void {
		this.vehicleService.getVehicleFormWith(info[0])
		.subscribe(response => {
			console.log('aaaaa'+JSON.stringify(response))
			this.modalData = JSON.stringify(response)
			this.modalData =JSON.parse(this.modalData)
			this.modalVehicleForm.patchValue({
				"owner_name": this.modalData[0].owner_name,
				"truck_no": this.modalData[0].truck_no,
				"pan_no": this.modalData[0].pan_no,
				'branch': this.modalData[0].branch,
				"account_no": this.modalData[0].account_no,
				"bank_name": this.modalData[0].bank_name,
				"bank_branch": this.modalData[0].bank_branch,
				"bank_ifsc": this.modalData[0].bank_ifsc
			});
		});	
		$("#default-modal").modal('show');
	};

	submit(){
		console.log(this.vehicleForm.value);
		//this.vehicleService.addNewVehicle(this.vehicleForm.value)
		//.subscribe(response => console.log(response));

		this.vehicleService.addNewVehicle(this.vehicleForm.value)
		.subscribe(response => 
		{
			
			if(response['status'])
			{
				swal('Save', 'Record save successfully', 'success');
				this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
					dtInstance.destroy();
					this.http.get(this.url + '/masters/vehicle/all')
						.map(this.extractData)
						.subscribe(forms => {
						this.vehicle_form = forms;
						console.log(this.vehicle_form);
						// Calling the DT trigger to manually render the table
						this.dtTrigger.next();
					});
				});
				
			}
			else
			{
				swal('Oops!', 'Something went wrong on the page!', 'error');
			}
		});
	};

	updateVehicle(){
		console.log(this.modalVehicleForm.value);
		console.log(this.modalData);

		this.query={
			"vehicle_oid" : this.modalData[0]._id,
			"vehicle_data" : this.modalVehicleForm.value
		}

		console.log(this.query);

		this.http.post( this.url + "/masters/vehicle/update", this.query)
		.subscribe(res => { 
			console.log(res.json());
			this.response = res.json();
			console.log(this.response.status);
			if (this.response.status){

				if (this.response.message === 'Vehicle Updated Successfully'){
					swal(
						'Success',
						'Vehicle Form Updated Successfully',
						'success'
					);

					this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
						dtInstance.destroy();
						this.http.get(this.url + '/masters/vehicle/all')
							.map(this.extractData)
							.subscribe(forms => {
							this.vehicle_form = forms;
							console.log(this.vehicle_form);
							// Calling the DT trigger to manually render the table
							this.dtTrigger.next();
						});
					});
				}

				if (this.response.message === 'Vehicle Information not Changed'){
					swal(
						'Info',
						'Vehicle information not changed',
						'info'
					);
				}
			}
			else{
				swal(
					'Unknown Error',
					'Please Refresh your page',
					'error'
				);
			}
			
		});
	};


	// DELETE CONSIGNOR
	deleteTruck(){
		console.log("Hello");

		this.query={
			"vehicle_id" : this.modalData[0]._id.$oid,
			"branch": this.modalData[0].branch
		}

		console.log(this.query);

		swal({
			title: 'Are you sure?',
			text: 'You want to delete Truck',
			type: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Yes, delete it!',
			cancelButtonText: 'No, keep it'
		}).then((result) => {
			if (result.value) {
			
				this.http.post(this.url + '/masters/vehicles/delete', this.query)
				.map(response => response.json())
				.subscribe(
					(response)=>{
						console.log(response);
						if (response["status"]){
							console.log(response);
							console.log("success");
							swal('Deleted!','Your Truck has been deleted.','success');

							this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
							dtInstance.destroy();
							this.http.get(this.url + '/masters/vehicle/all')
								.map(this.extractData)
								.subscribe(forms => {
								this.vehicle_form = forms;
								console.log(this.vehicle_form);
								// Calling the DT trigger to manually render the table
								this.dtTrigger.next();
							});
						});
							
						$("#default-modal").modal("hide");
							
						}else{
							swal("error","Oops , Somthing went wrong, Truck is not deleted","error");
						}
					},
					(error)=>console.log(error.json())
					);
			} 
		})
	}

	// END

}




// WEBPACK FOOTER //
// /Users/meghneel/work/shree_translogic_dashboard/src/app/masters/vehicle/vehicle.component.ts